import themeOverviewStyles from '@terminal/views/theme-overview/ThemeOverview.module.scss';
import { useTranslation } from 'react-i18next';

import styles from './AboutSection.module.scss';

export const AboutSection = ({ description }: { description: string }) => {
  const { t } = useTranslation(['widget']);

  return (
    <div className={styles.aboutWrapper}>
      <div className={themeOverviewStyles.titleMediumLabel}>
        {t('widget:themeOverview.aboutTheme')}
      </div>
      <div className={themeOverviewStyles.bodySmallText}>{description}</div>
    </div>
  );
};
